export default __webpack_public_path__ + "static/media/fridge2-afterA-1024w.afc6a0f7.png";